module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../resources/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = 2